module.exports = __webpack_public_path__ + "img/Asset1.301126cc.png";